/**
 * @module websocket.event.consumer
 */
import {
  PASSENGER_SERVER_EVENTS,
  FLIGHT_SERVER_EVENTS,
  AIRLINE_SERVER_EVENTS,
  AIRPORT_SERVER_EVENTS,
  PILOT_SERVER_EVENTS,
  AIRCRAFT_SERVER_EVENTS,
  BOOKING_SERVER_EVENTS,
  BAGGAGE_SERVER_EVENTS,
} from './enums'
import {
  HandleAircraftAdded,
  HandleAircraftUpdated,
  HandleAircraftDeleted,
  HandleAircraftListUpdated,
} from './event-handlers/aircraft'
import {
  HandleAirlineAdded,
  HandleAirlineUpdated,
  HandleAirlineDeleted,
  HandleAirlineListUpdated,
} from './event-handlers/airlines'
import {
  HandleAirportAdded,
  HandleAirportUpdated,
  HandleAirportDeleted,
  HandleAirportListUpdated,
} from './event-handlers/airports'
import {
  HandleBaggageAdded,
  HandleBaggageUpdated,
  HandleBaggageDeleted,
  HandleBaggageListUpdated,
} from './event-handlers/baggages'
import {
  HandleBookingAdded,
  HandleBookingUpdated,
  HandleBookingDeleted,
  HandleBookingListUpdated,
} from './event-handlers/bookings'
import {
  HandleFlightAdded,
  HandleFlightUpdated,
  HandleFlightDeleted,
  HandleFlightListUpdated,
} from './event-handlers/flights'
import {
  HandlePassengerUpdated,
  HandlePassengerDeleted,
  HandlePassengerListUpdated,
  HandlePassengerAdded,
} from './event-handlers/passengers'
import {
  HandlePilotAdded,
  HandlePilotUpdated,
  HandlePilotDeleted,
  HandlePilotListUpdated,
} from './event-handlers/pilots'

export async function eventConsumer(context) {
  const { type } = context
  switch (type) {
    // Passengers
    case PASSENGER_SERVER_EVENTS.NEW_PASSENGER:
      return HandlePassengerAdded(context)
    case PASSENGER_SERVER_EVENTS.PASSENGER_UPDATED:
      return HandlePassengerUpdated(context)
    case PASSENGER_SERVER_EVENTS.PASSENGER_DELETED:
      return HandlePassengerDeleted(context)
    case PASSENGER_SERVER_EVENTS.PASSENGER_LIST_UPDATED:
      return HandlePassengerListUpdated(context)
    // Flights
    case FLIGHT_SERVER_EVENTS.NEW_FLIGHT:
      return HandleFlightAdded(context)
    case FLIGHT_SERVER_EVENTS.FLIGHT_UPDATED:
      return HandleFlightUpdated(context)
    case FLIGHT_SERVER_EVENTS.FLIGHT_DELETED:
      return HandleFlightDeleted(context)
    case FLIGHT_SERVER_EVENTS.FLIGHT_LIST_UPDATED:
      return HandleFlightListUpdated(context)
    // Airlines
    case AIRLINE_SERVER_EVENTS.NEW_AIRLINE:
      return HandleAirlineAdded(context)
    case AIRLINE_SERVER_EVENTS.AIRLINE_UPDATED:
      return HandleAirlineUpdated(context)
    case AIRLINE_SERVER_EVENTS.AIRLINE_DELETED:
      return HandleAirlineDeleted(context)
    case AIRLINE_SERVER_EVENTS.AIRLINE_LIST_UPDATED:
      return HandleAirlineListUpdated(context)
    // Airports
    case AIRPORT_SERVER_EVENTS.NEW_AIRPORT:
      return HandleAirportAdded(context)
    case AIRPORT_SERVER_EVENTS.AIRPORT_UPDATED:
      return HandleAirportUpdated(context)
    case AIRPORT_SERVER_EVENTS.AIRPORT_DELETED:
      return HandleAirportDeleted(context)
    case AIRPORT_SERVER_EVENTS.AIRPORT_LIST_UPDATED:
      return HandleAirportListUpdated(context)
    // Pilots
    case PILOT_SERVER_EVENTS.NEW_PILOT:
      return HandlePilotAdded(context)
    case PILOT_SERVER_EVENTS.PILOT_UPDATED:
      return HandlePilotUpdated(context)
    case PILOT_SERVER_EVENTS.PILOT_DELETED:
      return HandlePilotDeleted(context)
    case PILOT_SERVER_EVENTS.PILOT_LIST_UPDATED:
      return HandlePilotListUpdated(context)
    // Aircraft
    case AIRCRAFT_SERVER_EVENTS.NEW_AIRCRAFT:
      return HandleAircraftAdded(context)
    case AIRCRAFT_SERVER_EVENTS.AIRCRAFT_UPDATED:
      return HandleAircraftUpdated(context)
    case AIRCRAFT_SERVER_EVENTS.AIRCRAFT_DELETED:
      return HandleAircraftDeleted(context)
    case AIRCRAFT_SERVER_EVENTS.AIRCRAFT_LIST_UPDATED:
      return HandleAircraftListUpdated(context)
    // Bookings
    case BOOKING_SERVER_EVENTS.NEW_BOOKING:
      return HandleBookingAdded(context)
    case BOOKING_SERVER_EVENTS.BOOKING_UPDATED:
      return HandleBookingUpdated(context)
    case BOOKING_SERVER_EVENTS.BOOKING_DELETED:
      return HandleBookingDeleted(context)
    case BOOKING_SERVER_EVENTS.BOOKING_LIST_UPDATED:
      return HandleBookingListUpdated(context)
    // Baggages
    case BAGGAGE_SERVER_EVENTS.NEW_BAGGAGE:
      return HandleBaggageAdded(context)
    case BAGGAGE_SERVER_EVENTS.BAGGAGE_UPDATED:
      return HandleBaggageUpdated(context)
    case BAGGAGE_SERVER_EVENTS.BAGGAGE_DELETED:
      return HandleBaggageDeleted(context)
    case BAGGAGE_SERVER_EVENTS.BAGGAGE_LIST_UPDATED:
      return HandleBaggageListUpdated(context)
    default:
      console.log('Unhandled socket event', type)
      break
  }
}
